"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Input = _interopRequireDefault(require("../Input"));
var _validation = require("../../utils/validation");
var _uuid = require("uuid");
var _AddList = require("./AddList.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * 可新增刪除項目列表
 */

const AddList = _ref => {
  let {
    data = [],
    onChange,
    validator
  } = _ref;
  const [value, setValue] = (0, _react.useState)("");
  const [message, setMessage] = (0, _react.useState)("");
  const addItemHandle = () => {
    let isPass = true;
    isPass = (0, _validation.required)(value);
    if (validator) isPass = (0, _validation.regex)(value, validator);
    if (!isPass) {
      setMessage("輸入的格式不正確！");
      return;
    }
    const newList = [...data, value];
    onChange(newList);
    setValue("");
  };
  const removeHandle = reItem => {
    const newList = data.filter(item => item !== reItem);
    onChange(newList);
  };
  const onKeyEnter = e => {
    let isPass = true;
    isPass = (0, _validation.required)(value);
    if (validator) isPass = (0, _validation.regex)(value, validator);
    if (!isPass) {
      setMessage("輸入的格式不正確！");
      return;
    }
    const newList = [...data, value];
    onChange(newList);
    setValue("");
  };
  const onInputChange = e => {
    const value = e.target.value;
    setValue(value);
    setMessage("");
  };
  return /*#__PURE__*/_react.default.createElement(_AddList.UiAddList, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement("span", null, "\u9805\u76EE"), /*#__PURE__*/_react.default.createElement("span", null, "\u522A\u9664")), data.map(item => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "item",
      key: (0, _uuid.v4)()
    }, /*#__PURE__*/_react.default.createElement("span", null, item), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "disabled_by_default",
      onClick: () => removeHandle(item)
    })));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "input"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    onChange: onInputChange,
    value: value,
    onKeyEnter: onKeyEnter,
    message: message
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "add",
    onClick: addItemHandle
  }))));
};
var _default = exports.default = AddList;
AddList.propTypes = {
  data: _propTypes.default.array,
  onChange: _propTypes.default.func,
  validator: _propTypes.default.any
};